var collectionSlider = function collectionSlider() {  
 var galleryElems = document.querySelectorAll('.product-swiper');
 for (var i=0, len = galleryElems.length; i < len; i++) {
   var galleryElem = galleryElems[i];
   var flkty = new Flickity( galleryElem, {
     contain: true,
     imagesLoad: true,
     pageDots: false,
     groupCells: true
   });
 }  
} 
collectionSlider()

var elements = document.getElementsByClassName("swatch_title");
      
var updateProduct = function(attribute) {
  console.log('working')
  
}


const productContainer = document.querySelector('#ProductGridContainer');
  // Click handler for entire DIV container
productContainer.addEventListener('mouseover', function (e) {
    var target = e.target;
 // But only alert for elements that have an alert-button class
  if (target.classList.contains('swatch_title')) {
     console.log('Hover active');
    var product_image = target.getAttribute("data-img");
  var product_url = target.getAttribute("data-variant-url");
  let card_image = target.closest('.card-wrapper').querySelectorAll('.card__image');
  let card_url = target.closest('.card-wrapper').querySelectorAll('.card__link')
  let secondary_image = target.closest('.card-wrapper').querySelectorAll('.secondary__image');
  if(secondary_image.length > 0) {
    secondary_image[0].remove();     
  }
  card_url[0].setAttribute('href', product_url);
  card_image[0].setAttribute('src', product_image);
  card_image[0].setAttribute('srcset', product_image);
  }
});

document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#collection-pagination',
      offset: 1000,
      loadingText: 'Loading More',
      callback: collectionSlider
    });
    collectionSlider()
});

